<template>
	<b-container fluid="xs">
		<b-row ref="rowEnvioVoto" class="container-fluid">
			<form @submit.prevent="cadastrarDados">
				<b-col cols="20" class="container-fluid" style="text-align:left;">
					<label ref="labelGenerico" class="text-left" style="text:bold;">Preencha seus dados:</label>
					<div v-if="interno" class="container-fluid">
						<input v-show="exibirCampo==='' || exibirCampo==='Matrícula'" ref="matricula" v-model="cadastro.matricula" v-mask="'######'" class="form-control" placeholder="Matrícula" type="text" autofocus @focus="exibirLabel">
					</div>
					<div class="container-fluid">
						<input v-show="exibirCampo==='CPF'" ref="cpf" v-model="cadastro.cpf" v-mask="'###.###.###-##'" class="form-control" placeholder="CPF" type="text" @focus="exibirLabel">
					</div>
					<div class="container-fluid">
						<input v-show="exibirCampo==='Nome Completo'" ref="nome" v-model="cadastro.nome" class="form-control" placeholder="Nome Completo" type="text" @focus="exibirLabel" @focusout="habilitarNascimento">
					</div>
					<div class="container-fluid">
						<input v-show="exibirCampo==='Nascimento'" ref="nascimento" v-model="cadastro.dataNascimento" class="form-control" placeholder="Nascimento" type="text" @focus="exibirLabel">
					</div>
					<div class="container-fluid">
						<input v-show="exibirCampo==='Email'" ref="email" v-model="cadastro.email" class="form-control" placeholder="Email" type="text" :disabled="desabilitarEmail" @focus="exibirLabel">
					</div>
					<div v-show="desabilitarEmail" class="container-fluid text-danger" :disabled="desabilitarEmail">* Email cadastrado na base de funcionários, se estiver desatualizado enviar email para <a href="mailto:com.eleitoral.cipa@sorocaba.sp.gov.br">com.eleitoral.cipa@sorocaba.sp.gov.br</a> a partir do seu novo email</div>
					<br>
					<br>
					<b-button type="button" size="sm" pill variant="success" @click="reiniciarCadastro">Corrigir</b-button>
					<b-button ref="btnEnvioDados" type="submit" size="sm" pill variant="success" @click="cadastrarDados">Avançar</b-button>
				</b-col>
			</form>
		</b-row>
	</b-container>
</template>

<script>
	import $ from 'jquery';
	import Validacao from '@/helpers/cpf';
	import Vue from 'vue';
	import VueMask from 'v-mask';

	Vue.use(VueMask);

	export default {
		data() {
			return {
				idVotoSelecionado: 0,
				interno: true,
				opcoes: [],
				idVotacao: 0,
				desabilitarEmail: false,
				campoAnterior: '',
				exibirCampo: 'Matrícula',
				cadastro: {
					matricula: '',
					cpf: '',
					nome: '',
					dataNascimento: '',
					email: ''
				}
			};
		},

		created: async function() {
			//this.votacoes = (await Votacao.listarVotacoes()).data;
		},

		methods: {
			cadastrarDados: function() {
				var vue = this;
				var invalido = vue.validarCadastro(vue.exibirCampo, vue.cadastro);

				if (invalido) {
					vue.$refs.btnEnvioDados.innerText = invalido;
					var campo = vue.exibirCampo.toLowerCase();
					if (campo === 'nome completo')
					{
						campo = 'nome';
					}
					vue.$refs[campo].focus();
					setTimeout(function() {
						vue.$refs.btnEnvioDados.innerText = 'Avançar';
					}, 1000);
				} else {
					if (vue.exibirCampo === 'Matrícula') {
						vue.tratarExibicaoCampo('CPF', vue.cadastro.matricula);
						vue.$refs.cpf.focus();
						return;
					}
					if (vue.exibirCampo === 'CPF') {
						vue.tratarExibicaoCampo('Nome Completo', vue.cadastro.cpf);
						vue.$refs.nome.focus();
						return;
					}
					if (vue.exibirCampo === 'Nome Completo') {
						vue.tratarExibicaoCampo('Nascimento', vue.cadastro.nome);
						vue.$refs.nascimento.focus();
						return;
					}
					if (vue.exibirCampo === 'Nascimento') {
						vue.habilitarEmail();
						vue.tratarExibicaoCampo('Email', vue.cadastro.dataNascimento);
						vue.$refs.email.focus();
						return;
					}
					if (vue.exibirCampo === 'Email')
					{
						vue.tratarExibicaoCampo('EmailPreenchido', vue.cadastro.email);
						vue.$refs.btnEnvioDados.innerText = 'Cadastrar Dados';
						return;
					}
					if (vue.exibirCampo === 'EmailPreenchido')
					{
						vue.cadastro.cpf = vue.cadastro.cpf.replace('.', '').replace('.', '').replace('-', '');
						$.ajax({
							url: `${window.Config.BASE_URL}/eleitor`,
							data: JSON.stringify(vue.cadastro),
							method: 'POST',
							contentType: 'application/json',
							success: function(res) {
								vue.$refs.btnEnvioDados.innerText = res;
							},
							error: function(message) {
								if (message && message.responseJSON && message.responseJSON.exceptionMessage)
								{
									vue.$refs.btnEnvioDados.innerText = 'Erro ao cadastrar dados (' + message.responseJSON.exceptionMessage + ')';
								}
								else
								{
									vue.$refs.btnEnvioDados.innerText = 'Erro ao cadastrar dados';
								}
								setTimeout(function() {
									vue.$refs.btnEnvioDados.innerText = 'Cadastrar dados';
								}, 3000);
							}
						});
					}
				}
			},

			consultarClasse: function(id) {
				try {
					return require('../../../../assets/img/' + id + '.jpg');
				}
				catch {
					return '';
				}
			},

			consultarImagem: function(id, temImagem) {
				if (temImagem) {
					try {
						return window.Config.BASE_URL + '/votacao/imagem/' + id;
					} catch {
						return require('../../../../assets/img/0.jpg');
					}
				}
				else {
					return require('../../../../assets/img/' + id + '.jpg');
				}
			},

			exibirLabel: function(event) {
				if (this.exibirCampo != this.campoAnterior)
				{
					this.$refs.labelGenerico.innerHTML = this.$refs.labelGenerico.innerHTML + '<br>' + event.target.placeholder;
					this.campoAnterior = event.target.placeholder;
				}
			},

			habilitarEmail: function() {
				var vue = this;
				var numCpf = vue.$refs.cpf.value.replace('.', '').replace('.', '').replace('-', '');
				var numMatricula = '';
				if (vue.$refs.matricula) {
					numMatricula = vue.$refs.matricula.value;
					if (numMatricula != '') {
						numMatricula = '&matricula=' + numMatricula;
					}
				}
				if (numCpf) {
					$.ajax({
						url: `${window.Config.BASE_URL}/eleitor` + '?cpf=' + numCpf + numMatricula,
						method: 'GET',
						contentType: 'application/json',
						success: function(res) {
							if (res)
							{
								vue.cadastro.email = res;
								vue.desabilitarEmail = true;
							}
						},
						error: function() {
						}
					});
				}
			},

			habilitarNascimento: function() {
				this.$refs.nascimento.type = 'date';
				this.$refs['nascimento'].focus();
			},

			reiniciarCadastro: function() {
				this.$refs.labelGenerico.innerHTML = 'Preencha seus dados:';
				this.cadastro.matricula = '';
				this.cadastro.cpf = '';
				this.cadastro.nome = '';
				this.cadastro.dataNascimento = '';
				this.cadastro.email = '';
				this.exibirCampo = 'Matrícula';
				this.campoAnterior = '';
			},

			selecionarVoto: function(id) {
				this.idVotoSelecionado = id;
				this.$refs.rowEnvioVoto.style.display = 'block';
				for(var i = 0; i < this.opcoes.length; i++) {
					if (document.getElementsByClassName('opcao-voto')[i].id != id) {
						document.getElementsByClassName('opcao-voto')[i].style.display = 'none';
					}
				}
			},

			tipoData: function() {
				this.$refs.nascimento.type = 'date';
			},

			tratarExibicaoCampo: function(proximo, valorAtual) {
				var fieldValue = valorAtual;
				if (fieldValue){
					if (fieldValue.split('-').length === 3)
					{
						fieldValue = fieldValue.split('-')[2] + '/' + fieldValue.split('-')[1] + '/' + fieldValue.split('-')[0];
					}

					this.$refs.labelGenerico.innerHTML = this.$refs.labelGenerico.innerHTML + ' ' + fieldValue + '<br>';
					this.exibirCampo = proximo;
				}
			},

			validarCadastro: function(campo, cadastro) {
				var retorno = undefined;

				if (this.interno) {
					if (campo === 'Matrícula' && cadastro.matricula.length === 0) {
						return 'Preencha Matrícula';
					}
				}
				if (campo === 'CPF' && !Validacao.validate(cadastro.cpf)) {
					return 'Preencha o Cpf';
				}
				if (campo === 'Nome Completo' && cadastro.nome.trim().split(' ').length < 2) {
					return 'Preencha o Nome Completo';
				}
				if (campo === 'Nascimento' && cadastro.dataNascimento === '') {
					return 'Preencha a Data de Nascimento';
				}
				if (campo === 'Email' && (cadastro.email.split('@').length !== 2 || cadastro.email.split('@')[1].split('.').length < 2)) {
					return 'Preencha o Email';
				}
				return retorno;
			}
		}
	};
</script>

<style></style>